module.exports = {"id":"159284","name":"Raffaele Palladino","rating":"72","photo":"./data/images/photos/0/159284.png","club":{"name":"La Spezia","logo":"./data/images/clubs/LaSpezia.png"},"positions":["AG","AD","BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RaffaelePalladino0.json
// module id = 3519
// module chunks = 0